
import axios from 'axios';
import moment from 'moment';
import Constant from '../../config/constant';

const baseURL = Constant.API_BASEURL;
const endPoint = Constant.URL_WEATHER;
const endPoint_SLA = Constant.URL_SLA;

// const APP_ID = '093c63d1d6dd2f0f77c6f14d91a19042';

class WeatherService {
    static getWeatherByPosition(requestParams, cancelToken) {

        console.log('[WeatherService.js]', requestParams);
        // console.log("[WeatherService.js]", window['runConfig']);
        if (requestParams === 0) {
            let list = [];
            console.log("[WeatherService.js] requestParams=0 List:", list.length);
            return { list };
        } else {
            const headers = Constant.KEYHEADER ? ({ 'X-Mosdac': Constant.APIWEATHER_KEY }) : ({});
            return axios.get(baseURL + endPoint + '?lon=' + requestParams.longitude + '&lat=' + requestParams.lat, {
                headers: headers,
                cancelToken,
                transformResponse: (response) => {

                    // console.log('[WeatherService.js] response:', response)
                    //validate response for known errors
                    if (response.hasOwnProperty('status')) {
                        console.log('Problem')
                        return 'Problem'
                    }

                    let list = []
                    var res = JSON.parse(response);
                    let len = Object.keys(res.data[0]).length;
                    // console.log("[WeatherService.js] response.data[0].length:" + len);
                    //Converting Object to Array of Key-value pairs
                    if (len > 0) {
                        for (var key in res) {
                            list.push(res[key])
                        }
                    }
                    // for (var i = 0; i < len; i++) {
                    //     list.push(res[i]);
                    // }
                    // console.log("[WeatherService] returnedList", list);
                    return { list };
                }
            })
            // .catch((error) => {
            //     console.log('[WeatherService] Catched ERROR', error);
            //     throw { message: error.response.data.debugMessage };
            // });
        }
    }
    static getSLAByPosition(requestParams, cancelToken) {

        console.log('[WeatherService.js getSLAByPosition ]', requestParams);
        // console.log("[WeatherService.js]", window['runConfig']);
        if (requestParams === 0) {
            let list = [];
            console.log("[WeatherService.js] requestParams=0 List:", list.length);
            return { list };
        } else {
            const headers = Constant.KEYHEADER ? ({ 'X-Mosdac': Constant.APIWEATHER_KEY }) : ({});
            return axios.get(baseURL + endPoint + '?lon=' + requestParams.longitude + '&lat=' + requestParams.lat, {
                headers: headers,
                cancelToken,
                transformResponse: (response) => {

                    // console.log('[WeatherService.js] response:', response)
                    //validate response for known errors
                    if (response.hasOwnProperty('status')) {
                        console.log('Problem')
                        return 'Problem'
                    }

                    let list = []
                    var res = JSON.parse(response);
                    let len = Object.keys(res.data[0]).length;
                    // console.log("[WeatherService.js] response.data[0].length:" + len);
                    //Converting Object to Array of Key-value pairs
                    if (len > 0) {
                        for (var key in res) {
                            list.push(res[key])
                        }
                    }
                    // for (var i = 0; i < len; i++) {
                    //     list.push(res[i]);
                    // }
                    // console.log("[WeatherService] returnedList", list);
                    return { list };
                }
            })
            // .catch((error) => {
            //     console.log('[WeatherService] Catched ERROR', error);
            //     throw { message: error.response.data.debugMessage };
            // });
        }
    }
    static prepareWRFChart(list) {
        console.log('prepareWRFChart: list=', list);
        if (list.length === 0) return;
        /** WeatherAPI response is in format:
        / * list = [[{queryParams}],[{info}],[{time1},{time2},{time3}, ...]]
        **/
        let data = list[2]
        /** Item-0 */
        const cloudiness = {
            label: 'Cloudiness (%)',
            backgroundColor: '#c1d8ed',
            borderWidth: 2,
            borderColor: '#a9ceef',
            fill: true,
            data: [],
            //plugins.legend.labels.usePointStyle:true
            pointStyle: 'line',
            yAxisID: 'cAxis'
        };
        /** Item-1 */
        const speeds = {
            label: 'Wind Speed (m/s) & Direction (deg-N)',
            backgroundColor: '#60b6ff',
            borderWidth: 2,
            borderColor: '#3399ff',
            fill: true,
            data: [],
            dir: []
        };
        /** Item-2 */
        const humidity = {
            label: 'Relative Humidity (%)',
            backgroundColor: '#FFF',
            borderWidth: 2,
            borderColor: '#3fa5a0',

            data: [],
            type: 'line',
            yAxisID: 'hAxis'
        };
        const temp = {
            label: 'Temperature (Deg.C)',
            backgroundColor: 'rgba(255,99,132,0.2)',
            borderWidth: 2,
            borderColor: 'rgba(255,99,132)',
            fill: true,
            // fill: false, //line
            data: [],
            //For Stacked Chart Only
            yAxisID: 'tAxis'
        };
        /** Item-3 */
        const rain = {
            label: 'Rain (mm)',
            backgroundColor: '#99CCFF',
            borderWidth: 2,
            borderColor: '#3399FF',
            data: [],
            yAxisID: 'rAxis'
        };
        /** Item-4 */
        const press = {
            label: 'Surface Pressure Deviation from 1000hPa',
            backgroundColor: '#ffcc00',
            borderWidth: 2,
            borderColor: '3ff9900',
            fill: true,
            data: [],
            yAxisID: 'pAxis'
        };

        const labels = [];
        let cumRain = 0.0;
        let currentRain = 0.0;
        for (let i = 0; i < data.length; i++) {
            let obj = data[i];

            labels.push(obj.time);
            temp.data.push(obj.t2);
            humidity.data.push(obj.rh2);
            cloudiness.data.push(Math.max(parseFloat(obj.clflo), parseFloat(obj.clfmi), parseFloat(obj.clfhi)));
            speeds.data.push(obj.ws10);
            speeds.dir.push(obj.wd10);
            press.data.push((1000 - parseFloat(obj.psfc) / 100));

            //Instantaneous Rain is subtraction of CumRain and currentRain
            currentRain = parseFloat(obj.rainnc) + parseFloat(obj.rainc);
            rain.data.push(currentRain - cumRain);
            cumRain = currentRain;

        }
        // console.log('Prepare H',humidity);
        // console.log('Prepare HL',labels1);
        return [{ labels: labels, datasets: [cloudiness] }, { labels: labels, datasets: [speeds] }, { labels: labels, datasets: [temp] }, { labels: labels, datasets: [rain, humidity] }, { labels: labels, datasets: [press] },
        { labels: labels, datasets: [rain, temp, press, cloudiness] }];
    }

    static getWRFTimes(list) {
        if (list.length === 0) return;
        else {
            const times = [];
            let data = list[2];
            for (let i = 0; i < data.length; i++) {
                let obj = data[i];
                times.push(obj.time);
            }
            return times;
        }
    }

    static getTimesfromResponse(arr) {
        if (arr.length === 0) return;
        else {
            const times = [];
            for (let i = 0; i < arr.length; i++) {
                let obj = arr[i];
                times.push(obj.time);
            }
            return times;
        }
    }

    static getWMSfromResponse(arr) {
        if (arr.length === 0) return;
        else {
            let mobj = moment.utc(arr[0].time, 'DD-MM-YY HHmm');
            let filename = 'SAC_WRF_FCST_5KM_' + mobj.format('YYYYMMDD') + '.nc'; //SAC_WRF_FCST_5KM_20220112.nc
            let startdate = mobj.format('YYYY-MM-DDT00:00:00'); //2022-01-10T00:00:00Z/2022-01-12T00:00:00Z
            let enddate = mobj.add(3, 'days').format('YYYY-MM-DDT00:00:00');
            return { name: filename, startdate: startdate, enddate: enddate };
        }
    }
    isEmptyJSObject(jsobj) {
        for (var p in jsobj) {
            if (jsobj.hasOwnProperty(p)) {
                return false;
            }
        }
        return true;
    }
    static axiosWeather(lat, lon) {
        
    }

    static prepareAxiosWeatherChart(jsres) {
        console.log('(WeatherService.prepareAXIOSWeatherChart): JSOBJ=', jsres);
        /** WeatherAPI response is in format:
        / * list = [[{queryParams}],[{info}],[{time1},{time2},{time3}, ...]]
        **/
        let data = jsres.data;
        let times = [];
        /** Item-0 */
        const cloudiness = {
            label: 'Cloudiness (%)',
            backgroundColor: '#c1d8ed',
            borderWidth: 2,
            borderColor: '#a9ceef',
            fill: true,
            data: [],
            //plugins.legend.labels.usePointStyle:true
            pointStyle: 'line',
            yAxisID: 'cAxis'
        };
        /** Item-1 */
        const speeds = {
            label: 'Wind Speed (m/s) & Direction (deg-N)',
            backgroundColor: '#60b6ff',
            borderWidth: 2,
            borderColor: '#3399ff',
            fill: true,
            data: [],
            dir: []
        };
        /** Item-2 */
        const humidity = {
            label: 'Relative Humidity (%)',
            backgroundColor: '#FFF',
            borderWidth: 2,
            borderColor: '#3fa5a0',

            data: [],
            type: 'line',
            yAxisID: 'hAxis'
        };
        const temp = {
            label: 'Temperature (Deg.C)',
            backgroundColor: 'rgba(255,99,132,0.2)',
            borderWidth: 2,
            borderColor: 'rgba(255,99,132)',
            fill: true,
            // fill: false, //line
            data: [],
            //For Stacked Chart Only
            yAxisID: 'tAxis'
        };
        /** Item-3 */
        const rain = {
            label: 'Rain (mm)',
            backgroundColor: '#99CCFF',
            borderWidth: 2,
            borderColor: '#3399FF',
            data: [],
            yAxisID: 'rAxis'
        };
        /** Item-4 */
        const press = {
            label: 'Surface Pressure Deviation from 1000hPa',
            backgroundColor: '#ffcc00',
            borderWidth: 2,
            borderColor: '3ff9900',
            fill: true,
            data: [],
            yAxisID: 'pAxis'
        };

        const labels = [];
        let cumRain = 0.0;
        let currentRain = 0.0;
        for (let i = 0; i < data.length; i++) {
            let obj = data[i];
            times.push(obj.time);

            labels.push(obj.time);
            temp.data.push(obj.t2);
            humidity.data.push(obj.rh2);
            cloudiness.data.push(Math.max(parseFloat(obj.clflo), parseFloat(obj.clfmi), parseFloat(obj.clfhi)));
            speeds.data.push(obj.ws10);
            speeds.dir.push(obj.wd10);
            press.data.push((1000 - parseFloat(obj.psfc) / 100));

            //Instantaneous Rain is subtraction of CumRain and currentRain
            currentRain = parseFloat(obj.rainnc) + parseFloat(obj.rainc);
            rain.data.push(currentRain - cumRain);
            cumRain = currentRain;

        }
        // console.log('Prepare H',humidity);
        // console.log('Prepare HL',labels1);
        return {
            'times':times,
            'chartdata':[{ labels: labels, datasets: [cloudiness] }, { labels: labels, datasets: [speeds] }, { labels: labels, datasets: [temp] }, { labels: labels, datasets: [rain, humidity] }, { labels: labels, datasets: [press] },
        { labels: labels, datasets: [rain, temp, press, cloudiness] }]
        };
    }

    static prepareAxiosSLAChart(jsres){

        console.log('prepareAXIOSWeatherChart: JSOBJ=', jsres);
        /** WeatherAPI response is in format:
        / * list = [[{queryParams}],[{info}],[{time1},{time2},{time3}, ...]]
        **/
        let data = jsres.data;
        let times = [];

        const trend = {
            label: 'Sea Level Anamoly Trend [mm/year]',
            backgroundColor: '#ffcc00',
            borderWidth: 2,
            borderColor: '3ff9900',
            fill: true,
            data: [],
            // sla:[],
            //For Stacked Chart Only
            yAxisID: 'tAxis'
        };

        const labels = [];
        for (let i = 0; i < data.length; i++) {
            let obj = data[i];

            console.log(obj.trend,obj.trend=='--');

            times.push(obj.time);

            labels.push(obj.time);
            trend.data.push(obj.trend);
            // trend.sla.push(obj.sla);

        }
        return {
            'times':times,
            'chartdata':[{ labels: labels, datasets: [trend] }]
        }
    }

    static prepareAxiosDailySLAChart(jsres){

        console.log('prepareAXIOSWeatherChart: JSOBJ=', jsres);
        /** WeatherAPI response is in format:
        / * list = [[{queryParams}],[{info}],[{time1},{time2},{time3}, ...]]
        **/
        let data = jsres.data;
        let times = [];

        const trend = {
            label: 'Sea Level Anamoly [m]',
            backgroundColor: '#ffcc00',
            // borderWidth: 1,
            // borderColor: 'black',
            color: 'black',
            fill: true,
            data: [],
            // sla:[],
            //For Stacked Chart Only
            yAxisID: 'tAxis',
            trendlineLinear: {
                colorMin: "#2d9cdb",
                colorMax: "#2d9cdb",
                lineStyle: "solid",
                width: 3,
                projection: false
            }
        };

        const labels = [];
        for (let i = 0; i < data.length; i++) {
            let obj = data[i];

            // console.log(obj.trend,obj.trend=='--');

            times.push(obj.time);

            labels.push(obj.time);
            trend.data.push(obj.sla);
            // trend.sla.push(obj.sla);

        }
        return {
            'times':times,
            'chartdata':[{ labels: labels, datasets: [trend] }]
        }
    }
}

export default WeatherService;
